import TextField from 'components/text-field';
import { Search } from 'lucide-react';
import { useIntl } from 'react-intl';
import googleTagManager from 'utils/google-tag-manager';
import { Box } from '@mui/material';

type Props = {
  search: {
    searchValue: string;
    setSearchValue: (v: string) => void;
  };
  resultLength: number;
};

const SearchFiles: React.FC<Props> = ({ search: { searchValue, setSearchValue }, resultLength }) => {
  const intl = useIntl();

  return (
    <Box display={'flex'} justifyContent={'flex-end'}>
      <TextField
        label={intl.formatMessage({ id: 'general.search' })}
        onBlur={(e) => {
          if (e.target.value.length > 0) {
            googleTagManager.push({
              event: 'files_search',
              searchTerm: e.target.value,
              searchResults: resultLength,
              pageUrl: window.location.pathname,
            });
          }
        }}
        value={searchValue}
        endAdornment={<Search size={18} />}
        sx={{ mb: 2 }}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
      />
    </Box>
  );
};

export default SearchFiles;
